import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

const environment = process.env.NODE_ENV || 'development';

export const env = createEnv({
  server: {
    API_URL: z.string().min(1),
    YOUTUBE_API_URL: z.url().min(1),
    APP_URL: z.string().min(1),
    ALLOWED_DEV_ORIGINS:
      environment === 'development'
        ? z
            .string()
            .optional()
            .refine(
              (value) =>
                value && value.includes(',') && value.split(',').length > 0,
              {
                message:
                  'ALLOWED_DEV_ORIGINS must be a comma-separated list of origins',
              },
            )
            .transform((value) =>
              typeof value === 'string' &&
              value.length > 1 &&
              value.includes(',')
                ? value?.split(',')
                : undefined,
            )
        : z
            .string()
            .optional()
            .transform((value) =>
              value &&
              typeof value === 'string' &&
              value.length > 1 &&
              value.includes(',')
                ? value?.split(',')
                : undefined,
            ),
  },
  client: {
    NEXT_PUBLIC_API_URL: z.url().min(1),
    NEXT_PUBLIC_YOUTUBE_API_URL: z.url().min(1),
    NEXT_PUBLIC_YT_WEBSOCKET_URL: z.url().min(1),
    NEXT_PUBLIC_APP_URL: z.url().min(1),
    NEXT_PUBLIC_WEBSITE_APP_URL: z.url().min(1),
    NEXT_PUBLIC_CWS_URL: z.string().min(1),
    NEXT_PUBLIC_POSTHOG_KEY: z.string().min(1),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().min(1),
  },
  runtimeEnv: {
    API_URL: process.env.API_URL,
    YOUTUBE_API_URL: process.env.YOUTUBE_API_URL,
    APP_URL: process.env.APP_URL,
    ALLOWED_DEV_ORIGINS: process.env.ALLOWED_DEV_ORIGINS,
    NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
    NEXT_PUBLIC_YOUTUBE_API_URL: process.env.NEXT_PUBLIC_YOUTUBE_API_URL,
    NEXT_PUBLIC_YT_WEBSOCKET_URL: process.env.NEXT_PUBLIC_YT_WEBSOCKET_URL,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_WEBSITE_APP_URL: process.env.NEXT_PUBLIC_WEBSITE_APP_URL,
    NEXT_PUBLIC_CWS_URL: process.env.NEXT_PUBLIC_CWS_URL,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  },
});
